"use client";

import { createContext, useContext } from "react";
import type { SidebarPanelLayout } from "./sidebar-panel";

export interface SidebarPanelContextValue {
  layout: SidebarPanelLayout;
  activeValue?: string;
  placement: "bar" | "more";
  moreOpen: boolean;
  setMoreOpen: (open: boolean) => void;
}

export const SidebarPanelContext = createContext<SidebarPanelContextValue | null>(null);

export const useSidebarPanel = (): SidebarPanelContextValue => {
  const ctx = useContext(SidebarPanelContext);
  if (!ctx) throw new Error("SidebarPanel parts must be used within <SidebarPanel>.");
  return ctx;
};
